import { useAuth0 } from '@auth0/auth0-react';
import React from 'react';
import { Button } from '@material-ui/core';

const LogoutButton = () => {
    const { logout } = useAuth0();
    return <Button color="primary" variant="outlined" onClick={() => { logout({ returnTo: window.location.origin }) }}>Logout</Button>
}

export default LogoutButton;